/**
 * @generated SignedSource<<d1cb2b5c9e0cc595421f42de40edc297>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BrandMessageExecutionStatusEnum = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "SCHEDULED" | "STALLED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly created: any;
      readonly deliveredCount: number | null;
      readonly deliveredFriendCount: number | null;
      readonly deliveredNormalCount: number | null;
      readonly executedAt: any | null;
      readonly failedCount: number | null;
      readonly id: string;
      readonly queriedAt: any | null;
      readonly sendFailedCount: number;
      readonly sendFailedPhoneNumbers: ReadonlyArray<string>;
      readonly sendFailedVariables: ReadonlyArray<any>;
      readonly sequence: number;
      readonly status: BrandMessageExecutionStatusEnum;
      readonly targetCount: number;
      readonly task: {
        readonly id: string;
      };
    };
  }>;
  readonly " $fragmentType": "BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection";
};
export type BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection$key = {
  readonly " $data"?: BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandMessageExecutionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandMessageExecution",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sequence",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "created",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "executedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "queriedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "targetCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deliveredFriendCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deliveredNormalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deliveredCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "failedCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sendFailedCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sendFailedPhoneNumbers",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sendFailedVariables",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BrandMessageTask",
              "kind": "LinkedField",
              "name": "task",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandMessageExecutionConnection",
  "abstractKey": null
};
})();

(node as any).hash = "abf45a6036e90e1234ef0b7024c9fed7";

export default node;
